import React, { useEffect, useState } from "react";
import { useAuth } from "../hooks/AuthProvider.js";
import Navigation from "./navbar/Navigation.tsx";
import { getSubscribers } from "../data/subscribers.js";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import {
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Stack,
  Heading,
  Text,
  Button,
  useColorModeValue
} from "@chakra-ui/react";
import { FiEdit } from "react-icons/fi";

function GetSubscribers() {
  const auth = useAuth();
  const navigate = useNavigate();
  const { newsletterId } = useParams();
  const [subscribers, setSubscribers] = useState(null);

  useEffect(() => {
    getSubscribers(newsletterId).then((subscribers) => setSubscribers(subscribers));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Flex h="80vh" padding={10} w={'full'}>
      <Stack spacing={4} w={'full'}>
        <Stack direction={['column', 'row']} w={'full'} spacing={8}>
          <FiEdit size={"4em"} />
          <Stack>
            <Heading lineHeight={1.1} fontSize={{ base: '2xl', sm: '3xl' }} align="left">
              Subscribers
            </Heading>
            <Text align="left">The list of current subscribers to this newsletter</Text>
          </Stack>
        </Stack>

      <Stack
      spacing={4}
      w={'full'}
      bg={useColorModeValue('white', 'gray.700')}
      rounded={'xl'}
      boxShadow={'lg'}
      p={6}
      my={12}>

        <TableContainer>
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>Email</Th>
                <Th>Created</Th>
                <Th>Edit</Th>
              </Tr>
            </Thead>
            <Tbody>
              {subscribers?.map((subscriber) => (
                <Tr key={subscriber.id}>
                  <Td>{subscriber.email}</Td>
                  <Td>{subscriber.date?.toDate()?.toDateString()}</Td>
                  <Td><Link class="table-link" to={"/subscribers/edit/" + subscriber.id + "/" + newsletterId}>Edit</Link></Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>

      </Stack>
      <Button bg={'blue.400'} color={'white'} w="75px" _hover={{ bg: 'blue.500', }} onClick={() => navigate("/subscribers/edit/new/" + newsletterId)}>Add</Button>
      
      </Stack>
    </Flex>
  )
}

const Subscribers = () => {
  const children = GetSubscribers();
  return (
    <Navigation children={children}/>
  );
};

export default Subscribers;